<template>
    <div class="container-fluid primary-container">
        <div class="row justify-content-center">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { detect } from 'detect-browser';

export default {
    name: 'Wrapper',
    props: ['errorCodes'],
    mounted: function () {
        const $browser = detect();
        this.setBrowser($browser);
        this.$store.commit('setErrorCodes', this.errorCodes);
        this.$store.commit('Auth/callbackUrl', window.callbackUrl);
        this.$store.commit('Auth/goToSmartCharts', window.go_to_smartcharts);
    },
    methods: {
        ...mapMutations(['setBrowser'])
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Wrapper.vue